const FieldInputRenderer = ({ field, value, onChange }) => {
  const commonClass =
    'w-full rounded-md border border-[#d8cfc0] bg-white px-3 py-2 text-sm text-[#130705] outline-none focus:border-[#785E32]';

  if (field.fieldType === 'textarea') {
    return (
      <textarea
        id={`field-${field.id}`}
        rows={4}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className={commonClass}
      />
    );
  }

  return (
    <input
      id={`field-${field.id}`}
      type={field.fieldType === 'url' ? 'url' : 'text'}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className={commonClass}
    />
  );
};

export default FieldInputRenderer;
